import { Typography } from '@mui/material';
import React from 'react';
import styles from './questions.module.scss';
import QuestionControl from './questionControl';
import { getClassName } from 'src/Core/utility/jsx';
import { SubTitle, Body } from '../landingComponents/typography';

export const QUESTION_TYPE = {
  description: 0,
  numberWithUnit: 1,
  rangeWithUnit: 2,
  single: 3,
  multiple: 4,
};

export const isQuestionValidPreviewState = ({
  min,
  max,
  value,
  currentUnit,
  type,
}) => {
  if (
    [
      QUESTION_TYPE.description,
      QUESTION_TYPE.multiple,
      QUESTION_TYPE.single,
    ].includes(type)
  ) {
    return true;
  }

  if (QUESTION_TYPE.numberWithUnit === type) {
    return value || currentUnit
      ? value !== undefined &&
          value !== '' &&
          value !== null &&
          currentUnit !== undefined &&
          currentUnit !== '' &&
          currentUnit !== null
      : true;
  }

  if (QUESTION_TYPE.rangeWithUnit === type) {
    return min || max || value || currentUnit
      ? min !== undefined &&
          min !== null &&
          min !== '' &&
          max !== undefined &&
          max !== null &&
          max !== '' &&
          value !== undefined &&
          value !== null &&
          value !== '' &&
          currentUnit !== undefined &&
          currentUnit !== null &&
          currentUnit !== ''
      : true;
  }

  return true;
};

export const getDataForUnits = (jsonRule, measurementUnits) => {
  let parsedJson;
  try {
    parsedJson = JSON.parse(jsonRule);
  } catch (error) {
    parsedJson = [[], [], []];
  }

  const parsedUnits = parsedJson[1] ?? [];
  const rules = parsedJson[2];
  const units = parsedUnits.length
    ? parsedUnits
        .map((unitId) => measurementUnits.find((i) => i.id === unitId))
        .filter((i) => !!i)
        .map((unitData, i) => ({
          ...unitData,
          unitRules: rules[i],
          descendants: parsedJson[0],
        }))
    : [];

  return units;
};

export default function Question({
  number,
  uuid,
  description,
  type,
  jsonRule,
  descendants,
  measurements,
  onValueChanged,
  data,
  previewMode,
}) {
  const { value, min, max, currentUnit } = data || {};
  const units = getDataForUnits(jsonRule, measurements);

  const availableValues = descendants
    .filter((i) => i)
    .map((i) => ({ title: i.description || '', value: i.uuid }));

  const currentUnitFilledWithRules = units.find(
    (i) => i.id === currentUnit?.id
  );

  const handlerControlChange = (valueType, val) => {
    const data = {
      value: value,
      min: min,
      max: max,
      currentUnit: currentUnitFilledWithRules,
      uuid: uuid,
      type: type,
    };

    switch (valueType) {
      case 'value':
        data.value = val;
        break;
      case 'min':
        data.min = val;
        break;
      case 'max':
        data.max = val;
        break;
      case 'unit':
        data.currentUnit = val;
        break;
      default:
        break;
    }

    onValueChanged(data);
  };

  return (
    <div className={styles.question}>
      <Body
        accent
        className={getClassName([
          styles.questionTitle,
          {
            [styles.invalidPreviewState]:
              previewMode &&
              !isQuestionValidPreviewState({
                min,
                max,
                value,
                currentUnit,
                type,
              }),
          },
        ])}
      >
        {description}
      </Body>
      {/* <Typography
        className={getClassName({
          [styles.invalidPreviewState]:
            previewMode &&
            !isQuestionValidPreviewState({
              min,
              max,
              value,
              currentUnit,
              type,
            }),
        })}
        variant="h6"
        pb={2}
      >
        {description}
      </Typography> */}
      <QuestionControl
        type={type}
        value={value}
        availableValues={availableValues}
        setValue={(val) => handlerControlChange('value', val)}
        min={min}
        setMin={(val) => handlerControlChange('min', val)}
        setMax={(val) => handlerControlChange('max', val)}
        max={max}
        currentUnit={currentUnitFilledWithRules}
        setCurrentUnit={(val) => handlerControlChange('unit', val)}
        units={units}
      />
    </div>
  );
}
